// extracted by mini-css-extract-plugin
export default {"wrap":"MicrositePagination_wrap__tQFcB","label":"MicrositePagination_label__M1gj4","controls":"MicrositePagination_controls__xcdxd","btn":"MicrositePagination_btn__5DU-6"};